export const SLOT_MINUTES = 20;
export const MAX_LESSONS = 3;
// Preserve the booking deadline used by the previous Academy booking modal.
export const BOOKING_DEADLINE_HOURS = 12;
export const CANCELLATION_DEADLINE_MINUTES = 30;
export const TIME_ZONE = 'Europe/Kyiv';
